import {Badge, Dropdown, Menu,} from "antd";
import type { ItemType } from "antd/es/menu/interface";
import {
  ApiOutlined,
  DownOutlined,
  KeyOutlined,
  CalendarOutlined,
  CarryOutOutlined,
  CheckOutlined,
  ControlOutlined,
  DashboardOutlined,
  DollarOutlined,
  FileAddOutlined,
  FileDoneOutlined,
  FileOutlined,
  FileSyncOutlined,
  FileUnknownOutlined,
  HolderOutlined,
  LogoutOutlined,
  MailOutlined,
  MenuOutlined,
  OneToOneOutlined,
  PaperClipOutlined,
  PartitionOutlined,
  PercentageOutlined,
  PictureOutlined,
  ProfileOutlined,
  RocketOutlined,
  ScheduleOutlined,
  SecurityScanOutlined,
  SettingOutlined,
  SolutionOutlined,
  TeamOutlined,
  ToolOutlined,
  TruckOutlined,
  UserOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";

import {Link, useLocation,} from "react-router-dom";
import {useContext} from "react";
import {ConfiguratorContext} from "../context";
import logo from "../assets/images/logo.jpg";
import {Permission} from "../api/models";
import NewQuoteWizard from "./Quote/NewQuoteWizard";
import {useSourcewellContext} from "../contexts/SourcewellCntContext";
import useApprovalCount from "../swr/useApprovalCount";

const SiteNav = (props: {
  handleSelect?: () => void;
}) => {
  const { handleSelect } = props;

  const context = useContext(ConfiguratorContext);
  const locationContext = useLocation();
  const userInfo = context.userInfo;
  const approvalCnt = useApprovalCount();

  const ApprovalItemLabel = () => {
    return <>
      <Link to="/approvals">Approvals
      &emsp;
      <Badge count={approvalCnt.data} size="default">
      </Badge>
      </Link>
    </>;
  }

  const SourcewellItemLabel = () => {

    const sourcewellCnt = useSourcewellContext().cnt;

    return <>
      <Link to="/sourcewellQuotes">Sourcewell
      &emsp;
      <Badge count={sourcewellCnt} size="default" />
      </Link>
    </>;
  }


  const isDealerManagement = ( context.isDealerManagement() || context.isSalesDesk() || context.isAdmin() || context.isEngineering() || context.isReleaseEngineering() ) && !context.isDealerSales()
  const isEngineering = context.isEngineering() || context.isEngineeringReadOnly();
  const isFinanceAdminEngineering = context.isAdmin() || context.isFinance() || isEngineering;
  const isAdminOrEngineering = context.isAdmin() || isEngineering;

  const menuItems: any[] = [
    context.isAdmin() && { key: '/system-config', label: <Link to='/system-config'>System Configuration</Link>, icon: <SettingOutlined style={{ fontSize: '20px' }} /> },
    isAdminOrEngineering && { key: '/categories', label: <Link to='/categories'>Categories</Link>, icon: <PartitionOutlined style={{ fontSize: '20px' }} /> },
    isAdminOrEngineering && { key: '/operations', label: <Link to='/operations'>Operations</Link>, icon: <SecurityScanOutlined style={{ fontSize: '20px' }} /> },
    (isEngineering || context.isSalesDesk()) && { key: '/shipping-destinations', label: <Link to='/shipping-destinations'>Shipping Destination</Link>, icon: <RocketOutlined style={{ fontSize: '20px' }} /> },
    context.hasPermission(Permission.DASH_COMPONENT_WRITE) && { 
      key: '/dash-component-menu', label: 'Dash Component', icon: <OneToOneOutlined style={{ fontSize: '20px' }} />, children: [
        { key: '/dash-component', label: <Link to='/dash-component'>Dash Component List</Link>, icon: <MenuOutlined style={{ fontSize: '20px' }} /> },
        { key: '/assembly-dash-component',  label: <Link to='/assembly-dash-component'>Assign Dash Component</Link>, icon: <ApiOutlined style={{ fontSize: '20px' }}  />},
        { key: '/dash-template',  label: <Link to='/dash-template'>Dash Layout Template</Link>, icon: <ControlOutlined style={{ fontSize: '20px' }}  />},
      ]
    },
    isAdminOrEngineering && { 
      key: "orderProcessing", label: 'Order Processing', icon: <HolderOutlined style={{ fontSize: '20px' }} />, children: [
        { key: '/vfd-review', label: <Link to='/vfd-review'>VFD Review</Link>, icon: <MenuOutlined style={{ fontSize: '20px' }} /> },
        { key: '/custom-work-review', label: <Link to='/custom-work-review'>Custom Work Review</Link>, icon: <MenuOutlined style={{ fontSize: '20px' }} /> },
        { key: '/engineering-teams', label: <Link to='/engineering-teams'>Engineering Teams</Link>, icon: <TeamOutlined style={{ fontSize: '20px' }} /> },
      ]
    },
    ( isDealerManagement ) && {
      key: null, label: 'Dealer Management', icon: <SettingOutlined style={{ fontSize: '20px' }} />, children: [
        { key: '/dealer', label: <Link to='/dealer'>Dealers</Link>, icon: <PartitionOutlined style={{ fontSize: '20px' }} /> },
        ((context.isDealerManagement() || context.isAdmin() ) && !context.isDealerSales() ) &&
        { key: '/users', label: <Link to='/users'>Users</Link>, icon: <UserOutlined style={{ fontSize: '20px' }} /> },
        { key: '/customer', label: <Link to='/customer'>Customers</Link>, icon: <TeamOutlined style={{ fontSize: '20px' }} /> },
        { key: '/salesSupport', label: <Link to='/salesSupport'>Sales Support</Link>, icon: <UserSwitchOutlined style={{ fontSize: '20px' }} /> },
      ]
    },
    (context.isAdmin() || context.isReleaseEngineering()) && {
      key: null, label: 'Epicor', icon: null, children: [
        { key: '/epicor-bulk-export', label: <Link to='/epicor-bulk-export'>Bulk Export</Link>, icon: <FileDoneOutlined style={{ fontSize: '20px' }}  /> },
        { key: '/epicor-sync-status', label: <Link to='/epicor-sync-status'>Sync Status</Link>, icon: <FileDoneOutlined style={{ fontSize: '20px' }}  /> },
      ]
    },
    isFinanceAdminEngineering && {
      key: null, label: 'Assemblies', icon: null, children: [
        { key: '/assemblies', label: <Link to='/assemblies'>Assembly List</Link>, icon: <FileDoneOutlined style={{ fontSize: '20px' }}  /> },
        { key: '/pending-assemblies', label: <Link to="/pending-assemblies">Assembly Import Review</Link>, icon: <FileAddOutlined style={{ fontSize: '20px' }}  /> },
        context.hasAnyPermission([Permission.ASSEMBLY_COST_READ, Permission.ASSEMBLY_COST_WRITE]) &&
        { key: '/assembly-cost-review', label: <Link to="/assembly-cost-review">Assembly Cost Review</Link>, icon: <FileAddOutlined style={{ fontSize: '20px' }}  /> },
        context.hasAnyPermission([Permission.RULES_WRITE, Permission.RULES_READ]) && 
          {key: '/rule-sets', label: <Link to="/rule-sets">Rule Sets</Link>, icon: <ToolOutlined style={{ fontSize: '20px' }} />},
          ],
    },

    context.isDealerSales() 
      //for dealers, only show single master schedule option, not the menu
      ? { key: '/master-schedule-view', label: <Link to='/master-schedule-view'>Master Schedule</Link>, icon: <FileDoneOutlined style={{ fontSize: '20px' }}  /> }
      : { key: 'master-schedule', label: "Master Schedule", icon: <CalendarOutlined style={{ fontSize: '20px' }}  />,  children: [
          { key: '/master-schedule-view', label: <Link to='/master-schedule-view'>Schedule</Link>, icon: <FileDoneOutlined style={{ fontSize: '20px' }}  /> },
          (context.hasPermission(Permission.MASTER_SCHEDULE_WRITE)) && { key: '/master-schedule-upload', label: <Link to='/master-schedule-upload'>Upload</Link>, icon: <FileSyncOutlined style={{ fontSize: '20px' }}  /> },
          { key: '/master-schedule-slots', label: <Link to='/master-schedule-slots'>Production Slots</Link>, icon: <CarryOutOutlined style={{ fontSize: '20px' }}  /> },
          { key: '/master-schedule-kpi', label: <Link to='/master-schedule-kpi'>KPI</Link>, icon: <ScheduleOutlined style={{ fontSize: '20px' }}  /> },
        ]
      },
    isAdminOrEngineering && { key: '/models', label: <Link to="/models">Models</Link>, icon: <DashboardOutlined style={{ fontSize: '20px' }}  /> },
    { key: '/configurator', 
      label: <NewQuoteWizard type="text" className="navMenuButton">Configurator</NewQuoteWizard>,
      icon: <ToolOutlined style={{ fontSize: '20px' }} /> 
    },
    { key: '/quotes', label: <Link to="/quotes">Quotes</Link>, icon: <PaperClipOutlined style={{ fontSize: '20px' }} /> },
    !context.isDealerSales() && { key: '/orders', label: <Link to="/orders">Orders</Link>, icon: <ProfileOutlined style={{ fontSize: '20px' }} /> },
    ( context.isSourcewellManager() ) && { key: '/sourcewellQuotes', label: <SourcewellItemLabel />, icon: <ProfileOutlined style={{ fontSize: '20px' }} /> },
    ( context.isBts() ) && { key: '/bts', label: <Link to="/bts">BTS</Link>, icon: <ProfileOutlined style={{ fontSize: '20px' }} /> },
    ( context.isLogistics() ) && { key: '/logistics', label: <Link to="/logistics">Logistics</Link>, icon: <TruckOutlined style={{ fontSize: '20px' }} /> },
    ( context.isInternalSales() ) && { key: '/inventory', label: <Link to="/inventory">Inventory</Link>, icon: <ProfileOutlined style={{ fontSize: '20px' }} /> },
    ( context.isAdmin() || context.isReporting() || context.isSalesDesk() ) && { key: '/reporting', label: <Link to="/reporting">Reporting</Link>, icon: <FileOutlined style={{ fontSize: '20px' }} /> },
    context.isFinance() && { key: '/pricing', label: <Link to="/pricing">Pricing</Link>, icon: <DollarOutlined style={{ fontSize: '20px' }}  /> },
    (context.isAdmin() || isEngineering || context.isSalesManager() || context.isSalesDesk() || context.isProcurement() || context.isFinance() || context.isReleaseEngineering() || context.isSourcewellManager() || context.isInternalSales() )
    && {
      key: '/approvals',
      label: <ApprovalItemLabel />,
      icon: <CheckOutlined 
        style={{ fontSize: '20px' }} />
    },
    { key: '/internal-user', label: <Link to="/internal-user">Internal User</Link>, icon: <SolutionOutlined style={{ fontSize: '20px' }}  /> },
    (context.isAdmin() || context.isSalesDesk() ) &&
      { key: '/user-sales-teams', label: <Link to='/user-sales-teams'>Sales Teams</Link>, icon: <TeamOutlined style={{ fontSize: '20px' }} /> },
    context.isInternalSales() && {
      key: null, label: 'Setup', icon: <FileUnknownOutlined style={{ fontSize: '20px' }} />, children: [
        //{ key: '/lifeCycleNotification', label: <Link to="/lifeCycleNotification">Life Cycle Notification</Link>, icon: <MailOutlined style={{ fontSize: '20px' }}  /> },
        (context.isAdmin() || context.isSalesDesk() ) &&
        { key: '/notification-events', label: <Link to="/notification-events">Notifications</Link>, icon: <MailOutlined style={{ fontSize: '20px' }}  /> },
        (context.isAdmin() || context.isSalesDesk() ) &&
        { key: '/approval-steps', label: <Link to="/approval-steps">Approval Steps</Link>, icon: <CheckOutlined style={{ fontSize: '20px' }}  /> },
        (context.hasPermission(Permission.CONCESSION_CRITERIA_WRITE)) &&
        { key: '/concession-criteria', label: <Link to="/concession-criteria">Concession Criteria</Link>, icon: <PercentageOutlined style={{ fontSize: '20px' }}  /> },
        { key: '/image-library', label: <Link to="/image-library">Image Library</Link>, icon: <PictureOutlined style={{ fontSize: '20px' }}  /> },
      ]
    },
    { key: '/logout', label: (<a href={context.api.baseUrl + '/logout'}>Logout</a>), icon: <LogoutOutlined style={{ fontSize: '20px' }} /> },
  ]

  // Account menu hanging off the user's name. Admin-only for now, so a non-admin
  // keeps the plain label rather than an empty popup.
  const userMenuItems = [
    context.isAdmin() && {
      key: '/personal-access-tokens',
      label: <Link to="/personal-access-tokens">Access Tokens</Link>,
      icon: <KeyOutlined />,
    },
  ].filter(Boolean) as ItemType[];

  const defaultOpenKeys = new Array<string>();
  if ( true ) {
    defaultOpenKeys.push( "orderProcessing" );
  }

  return <>
    <div className="menu-outer-layout">
      <div>
        <div className="menu-logo" >
          <Link to="/">
            <img src={logo} style={{ width: 175, padding: 10 }} alt="" />
          </Link>
        </div>
      <style>
        {`
          .navMenuButton {
            padding: 0px;
            color: rgba(255, 255, 255, 0.65);
          }
          .navMenuButton span {
            transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), margin 0.3s, color 0.3s;
          }
          .navMenuButton:hover span {
            font-weight: bold;
            color: white;
          }
          `}
      </style>
        <Menu
          data-testid="site-nav"
          theme="dark"
          mode="inline"
          defaultSelectedKeys={["1"]}
          defaultOpenKeys={defaultOpenKeys}
          items={menuItems}
          selectedKeys={["/" + locationContext.pathname.split("/")[1]]}
          onSelect={handleSelect}
        >
        </Menu>
      </div>
      <div>
        {userMenuItems.length > 0
          ? (<Dropdown menu={{ items: userMenuItems }} trigger={['click']} placement="topLeft">
              <div className="user-info user-info-menu" role="button" tabIndex={0}>
                <strong>{userInfo?.name || userInfo?.email}</strong>
                <DownOutlined className="user-info-caret" />
              </div>
            </Dropdown>)
          : (<div className="user-info">
              <strong>{userInfo?.name}</strong>
            </div>)}
        {context.isDealerSales() &&
        <div className="dealer">
          <strong>{userInfo?.dealerName}</strong>
        </div>
        }
      </div>
    </div>
  </>


}
export default SiteNav;

